import { IconWrapper } from '../runtime';
export default IconWrapper('pdf_format_s', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2Z",
      "fill": "#EB2F3B"
    }
  }), h("path", {
    "attrs": {
      "d": "M2 16C0.895431 16 0 15.1046 0 14L16 14C16 15.1046 15.1046 16 14 16L2 16Z",
      "fill": "#CE1E29"
    }
  }), h("path", {
    "attrs": {
      "d": "M8 16L8 14L16 14C16 15.1046 15.1046 16 14 16L8 16Z",
      "fill": "#FF4F5A"
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M7 2.5H10.25C11.7688 2.5 13 3.73122 13 5.25C13 6.76878 11.7688 8 10.25 8H8.5V11H5.5C4.25736 11 3.25 9.99264 3.25 8.75C3.25 7.50736 4.25736 6.5 5.5 6.5H7V2.5ZM8.5 6.5H10.25C10.9404 6.5 11.5 5.94036 11.5 5.25C11.5 4.55964 10.9404 4 10.25 4H8.5V6.5ZM7 8H5.5C5.08579 8 4.75 8.33579 4.75 8.75C4.75 9.16421 5.08579 9.5 5.5 9.5H7V8Z",
      "fill": "white"
    }
  })]);
});